import React from "react";

import styles from "./ReInvestToNewCore.module.scss";

import Button from "../../../components/Button/Button";
import NewFundSearch from "../NewFund/NewFundSearch/NewFundSearch";
import {AddNewFund} from "../NewFund/AddNewFund/AddNewFund";

const ReInvestToNewCore = ({ onClose }) => {
  return (
    <div className={styles["tax-modal-container"]}>
      <div className={styles["title-container"]}>
        <div className={styles["tax-modal-title"]}>
         Choose the fund you'd like to use for your Individual Account
        </div>
      </div>
      <div className={styles["text-container"]}>
        <AddNewFund onClose={onClose}/>
      </div>
      {/*<div className={styles["tax-button"]} onClick={onClose}>*/}
      {/*  <Button*/}
      {/*    id="close-tax-withholding-modal"*/}
      {/*    type="primary"*/}
      {/*    size="small"*/}
      {/*  >*/}
      {/*    OK*/}
      {/*  </Button>*/}
      {/*</div>*/}
    </div>
  );
};

export default ReInvestToNewCore;
